export default function createUIDMaker() {
	let uid = 0;
	return () => uid++;
}
